﻿export class AddressInformationData {
    id: string = "";
    text: string = "";
}

export class AddressFilterData {
    country: string = "";
    province: string = "";
    district: string = "";
}